module.exports = __webpack_public_path__ + "img/loc.0a74fcbb.webp";